var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40625 5.1875C3.40625 7.125 4.875 8.59375 6.8125 9.59375L8.28125 8.125C8.48958 7.91667 8.71875 7.86458 8.96875 7.96875C9.71875 8.21875 10.5104 8.34375 11.3438 8.34375C11.5312 8.34375 11.6875 8.40625 11.8125 8.53125C11.9375 8.65625 12 8.8125 12 9V11.3438C12 11.5312 11.9375 11.6875 11.8125 11.8125C11.6875 11.9375 11.5312 12 11.3438 12C8.21875 12 5.54167 10.8958 3.3125 8.6875C1.10417 6.45833 0 3.78125 0 0.65625C0 0.46875 0.0625 0.3125 0.1875 0.1875C0.3125 0.0625 0.46875 0 0.65625 0H3C3.1875 0 3.34375 0.0625 3.46875 0.1875C3.59375 0.3125 3.65625 0.46875 3.65625 0.65625C3.65625 1.48958 3.78125 2.28125 4.03125 3.03125C4.11458 3.30208 4.0625 3.53125 3.875 3.71875L2.40625 5.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phone_white.4cb70cc1eb5071154115d2eb0625f01d.svg";
export { ForwardRef as ReactComponent };